import type { FC, ReactNode } from 'react';
import { ToastContainer } from 'react-toastify';
import { PendingInvitationModal } from '@/shared/ui/PendingInvitationModal';
import Navigation from '../navigation/Navigation';
import 'react-toastify/dist/ReactToastify.css';

interface AppLayoutProps {
  children: ReactNode;
}

export const AppLayout: FC<AppLayoutProps> = ({ children }) => {
  return (
    <>
      <Navigation />
      <main className="app-main">{children}</main>
      <ToastContainer position="top-center" />
      {/* Show invitation modal for pending staff members */}
      <PendingInvitationModal />
    </>
  );
};
